/**
 * O canal de ouvidoria do órgão como o formulário público o vê — espelho em camelCase do
 * `CanalPublicoResponse` do back-end (`GET api/ouvidoria/publico/canal`).
 *
 * O canal é o **teto**: ele habilita anonimato, sigilo e anexo, e a ouvidoria que receber a
 * manifestação escolhe dentro disso. Por isso a tela esconde o que o canal não permite, mas o
 * 400 da abertura ainda pode recusar algo que aqui aparece habilitado.
 */
export interface CanalPublico {
  codOrgaoOrg: number;

  nome: string;
  email?: string | null;
  telefonePrincipal?: string | null;
  telefoneSecundario?: string | null;

  endereco: EnderecoCanal;

  /** Texto já derivado da grade pelo back-end — o portal só publica. */
  horarioAtendimento?: string | null;
  atendeFeriado: boolean;
  horarios: readonly HorarioCanal[];

  /** Nome do ouvidor responsável (o social, quando houver); nulo quando ele não está ativo. */
  responsavel?: string | null;

  permiteAnonimato: boolean;
  permiteSigiloIdentidade: boolean;
  permiteAnexo: boolean;
  permiteContestacao: boolean;
  prazoContestacao?: number | null;
  permiteEncaminhamento: boolean;
  prazoEncaminhamento?: number | null;

  prazoPadrao: number;
  unidadePrazo: UnidadePrazo;
}

export interface EnderecoCanal {
  cep?: string | null;
  logradouro?: string | null;
  numero?: string | null;
  complemento?: string | null;
  bairro?: string | null;
  cidade?: string | null;
  uf?: string | null;
}

export interface HorarioCanal {
  /** 0 = domingo ... 6 = sábado. */
  diaSemana: number;
  ativo: boolean;
  /** "HH:mm"; nulo quando o dia está inativo. */
  horaInicio?: string | null;
  horaFim?: string | null;
}

/** Unidade única do módulo — o prazo do canal e o da manifestação usam as mesmas chaves. */
export type UnidadePrazo = 'DiasUteis' | 'DiasCorridos';

/**
 * "30 dias úteis" / "30 dias corridos". Função pura porque o mesmo texto aparece na etapa de
 * prazo, no selo de prazo máximo e no comprovante em PDF.
 */
export function textoPrazo(prazo: number, unidade: UnidadePrazo | string): string {
  if (prazo === 1) return unidade === 'DiasCorridos' ? '1 dia corrido' : '1 dia útil';

  return unidade === 'DiasCorridos' ? `${prazo} dias corridos` : `${prazo} dias úteis`;
}
